//import liraries
import React, { useState, useEffect } from 'react';
import useDarkMode from '../../hooks/useDarkMode';
import useThemeColor from "../../hooks/useThemeColor";
import { useSelector } from 'react-redux';
import CustomModal from '../../components/CustomComponents/modal/customModal';
import MediaLibrary from '../../components/CustomComponents/mediaLibarary/mediaLibarary';

// create a component
const CategoryIconSelection = ({ selectedIcon, setSelectedIcon }) => {
    const [showMediaLibrary, setShowMediaLibrary] = useState(false);
    const [imageError, setImageError] = useState(false);

    // Get app settings from Redux
    const appSettings = useSelector((state) => state.appSettings);
    const { appTheme } = appSettings;
    
    // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

    // Get theme color from centralized hook
  const themeColor = useThemeColor();

    
    useEffect(() => {
        console.log("=== Category Icon Selection ===");
        console.log("Selected Icon Path:", selectedIcon);
        console.log("Full URL would be:", window.location.origin + selectedIcon);
        setImageError(false);
    }, [selectedIcon]);

    const handleRemoveIcon = () => {
        setSelectedIcon(null);
        setImageError(false);
    }

  return (
        <>
            <div className="text-center">
                <div 
                    onClick={() => setShowMediaLibrary(true)}
                    className="d-flex flex-column justify-content-center align-items-center border-2 border-dashed rounded-3 mx-auto shadow-sm position-relative"
                    style={{ 
                        minHeight: "140px", 
                        width: "140px",
                        cursor: "pointer",
                        borderColor: selectedIcon ? themeColor : "#dee2e6",
                        transition: "all 0.3s ease",
                        background: selectedIcon ? `linear-gradient(135deg, ${themeColor}15 0%, ${themeColor}08 100%)` : "#ffffff",
                        backgroundColor: isDarkMode ? "#2d3436" : "#ffffff"
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = themeColor;
                        e.currentTarget.style.transform = "scale(1.02)";
                        e.currentTarget.style.boxShadow = `0 4px 12px ${themeColor}30`;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = selectedIcon ? themeColor : "#dee2e6";
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    {selectedIcon ? (
                        <div className="position-relative d-flex justify-content-center align-items-center overflow-hidden" style={{ width: "100%", height: "100%" }}>
                            {!imageError ? (
                                <img
                                    key={selectedIcon}
                                    src={selectedIcon}
                                    alt="Category Icon"
                                    className="img-fluid"
                                    style={{
                                        maxHeight: "100px",
                                        maxWidth: "100px",
                                        width: "auto",
                                        height: "auto",
                                        objectFit: "contain",
                                        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
                                        imageRendering: "-webkit-optimize-contrast",
                                        display: "block",
                                        margin: "auto"
                                    }}
                                    onError={(e) => {
                                        console.error("❌ Failed to load icon from path:", selectedIcon);
                                        console.error("Attempted URL:", e.target.src);
                                        setImageError(true);
                                    }}
                                    onLoad={(e) => {
                                        console.log("✓ Icon loaded successfully:", selectedIcon);
                                        console.log("Actual loaded URL:", e.target.src);
                                        setImageError(false);
                                    }}
                                />
                            ) : (
                                <div className="text-center p-2">
                                    <i className="fa fa-exclamation-triangle text-warning" style={{ fontSize: "32px" }}></i>
                                    <div className="small text-danger mt-2 fw-bold">Icon failed to load</div>
                                    <div className="small text-muted mt-1" style={{ fontSize: "9px", wordBreak: "break-all", maxWidth: "120px" }}>
                                        {selectedIcon}
                                    </div>
                                </div>
                            )}
                            <div 
                                className="position-absolute top-0 end-0 text-white rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    fontSize: "12px",
                                    transform: "translate(8px, -8px)",
                                    backgroundColor: themeColor,
                                    boxShadow: `0 2px 4px ${themeColor}60`,
                                    cursor: "pointer",
                                    zIndex: 10
                                }}
                            >
                                <i className="fa fa-edit"></i>
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex flex-column align-items-center">
                            <div 
                                className="text-white rounded-circle d-flex align-items-center justify-content-center mb-2"
                                style={{
                                    width: "48px",
                                    height: "48px",
                                    fontSize: "20px",
                                    backgroundColor: themeColor,
                                    background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                                    boxShadow: `0 4px 8px ${themeColor}40`
                                }}
                            >
                                <i className="fa fa-plus"></i>
                            </div>
                            <span
                                className="text-muted fw-medium"
                                style={{ fontSize: "14px" }}
                            >
                                Upload Icon
                            </span>
                            <small className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                Click to select
                            </small>
                        </div>
                    )}
                </div>
                
                {selectedIcon && (
                    <div className="text-center mt-3">
                        <button
                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                            style={{ fontSize: "12px" }}
                            onClick={handleRemoveIcon}
                        >
                            <i className="fa fa-trash me-1"></i>
                            Remove Icon
                        </button>
                        <div className="mt-2 p-2 bg-light rounded" style={{ fontSize: "10px" }}>
                            <strong>Debug:</strong>
                            <div className="text-break">{selectedIcon}</div>
                            <a href={selectedIcon} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary mt-1">
                                Test Link
                            </a>
                        </div>
                    </div>
                )}
                 
            </div>
            <CustomModal
                title={"Select an Icon"}
                isOpen={showMediaLibrary}
                onClose={() => setShowMediaLibrary(false)}
                showButton={false}
                modalSize={"modal-lg"}
                themeColor={themeColor}
            >
                <MediaLibrary
                    onSelectImage={(src) => {
                        setSelectedIcon(src);
                        setShowMediaLibrary(false);
                    }}
                />
            </CustomModal>
        </>
    );
};


export default CategoryIconSelection;
